// extracted by mini-css-extract-plugin
export var texturedBg = "Story-module--texturedBg--3V1RS";
export var heroDetailsContainer = "Story-module--heroDetailsContainer--1VUYO";
export var videoSpace = "Story-module--videoSpace--3XkVu";
export var quote = "Story-module--quote--qWSYC";